/* eslint-disable no-console */
import axios from "axios";
import store from "../store";

const APIUrl = process.env.VUE_APP_BASE_URL;

const axiosBase = axios.create({
  baseURL: APIUrl,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

const getAPI = axios.create({
  baseURL: APIUrl,
  withCredentials: true,
});

getAPI.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

getAPI.interceptors.response.use(
  (response) => {
    // Show success notification for non-GET requests for admin users
    if (
      !store.getters.snackShow &&
      response.config.method !== "get" &&
      store.getters.profile.role === "ADMIN" &&
      !response.config.skipGlobalSuccessSnack
    ) {
      store.commit("snackSuccess", true);
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        await axiosBase.post("/api/auth/refresh-token/");
        return getAPI(originalRequest);
      } catch (refreshError) {
        store.dispatch("logoutUser");
        return Promise.reject(error);
      }
    }

    if (error.response && error.response.status !== 401 && store.getters.profile.role === "ADMIN") {
      const snackBody = {
        statusText: error.response.statusText,
      };

      if (error.response.data && typeof error.response.data === "object") {
        const entries = Object.entries(error.response.data);
        if (entries.length > 0) {
          const [[key, value]] = entries;
          if (Array.isArray(value)) {
            snackBody.message = `${key}: ${value[0]}`;
          } else {
            snackBody.message = `${key}: ${value}`;
          }
        }
      }
      store.commit("updateSnackbar", snackBody);
    }

    return Promise.reject(error);
  },
);

axiosBase.interceptors.response.use(undefined, (error) => {
  if (error.response && error.response.status === 401) {
    if (!error.config.url.includes("/auth/obtain_token")) {
      store.dispatch("logoutUser");
    }
  }
});

export { axiosBase, getAPI };
